import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.153 21.667c-.596 0-1.105-.21-1.524-.63-.42-.42-.63-.928-.63-1.524V3H.666V1.667h5.333V.64h8v1.026h5.334V3h-1.334v16.513c0 .613-.205 1.126-.616 1.537-.411.411-.924.617-1.538.617H4.153ZM16.666 3H3.333v16.513a.8.8 0 0 0 .23.59.8.8 0 0 0 .59.23h11.692c.206 0 .394-.085.565-.256.17-.17.256-.359.256-.564V3Zm-9.59 14.667H8.41v-12H7.076v12Zm4.513 0h1.333v-12H11.59v12Z" }, null, -1)
  ]))]))
}
export default { render: render }